import React from 'react'
import { FieldSurfaceThemeProvider } from './FieldSurfaceThemeProvider'

type FormKiotThemeProviderProps = {
  children: React.ReactNode
}

/** Bọc form modal — surface `form`. */
export function FormKiotThemeProvider({ children }: FormKiotThemeProviderProps) {
  return <FieldSurfaceThemeProvider surface="form">{children}</FieldSurfaceThemeProvider>
}

export default FormKiotThemeProvider
